import apiClient from "./client";
import type {
  GetTemplateMailsParams,
  TemplateMailsListResponse,
} from "../types/mail";

export const getTemplateMails = async (
  params: GetTemplateMailsParams
): Promise<TemplateMailsListResponse> => {
  const { data } = await apiClient.get<TemplateMailsListResponse>(
    "/template_mails",
    { params }
  );
  return data;
};
